import { AppState } from 'state/types';

import getParentState from '../selectors';

export default function getState(state: AppState) {
  return getParentState(state).globalUI;
}
